module.exports = __webpack_public_path__ + "media/images/lb/537-c7bddd885fae78b9022ef454c77362b3.svg";